import sourceEvent from "./sourceEvent";
import point from "./point";

export default function(node) {
  var event = sourceEvent();
  if (event.changedTouches) event = event.changedTouches[0];
  return point(node, event);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-drag/~/d3-selection/src/mouse.js
// module id = nDvx
// module chunks = 0